import { h } from 'preact'
import Icon from '../../assets'
import globals from '../../../utils/globals'

const TitleCell = () => {
  return (props: any) => {
    const { contentType, id, title } = props

    const control = `/${contentType}/${id}`
    const destination = `${globals('communityUrl')}/${contentType}s/${id}`

    return (
      <div className='overview__table-title'>
        <a href={window.location.origin + control} class='qa-title-link'>{title}</a>
        {destination &&
          <a className='overview__destination-icon qa-destination-link' href={destination} target='_blank'>
            <Icon icon='externalLink' width={16} height={16} />
          </a>
        }
      </div>
    )
  }
}

export default TitleCell
